// extracted by mini-css-extract-plugin
export var sliderRange = "_op-2";
export var sliderRoot = "_op-0";
export var sliderThumb = "_op-3";
export var sliderTrack = "_op-1";